module.exports = __webpack_public_path__ + "static/img/onlinestore1.6cc55ae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onlinestore1.jpeg
// module id = 672
// module chunks = 1